import { Entity, IEntity } from "./Entity";
import { IProject } from "./Project";

export interface IProjectDep extends IEntity {
    ProjectID?: number;              // The main project (depends on another)
    DependentProjectID?: number;     // The project it depends on
    Project?: IProject;              // Parent project reference
    DependentProject?: IProject;     // Dependency project reference
}

export class ProjectDep extends Entity implements IProjectDep {
    public ProjectID = null;
    public DependentProjectID = null;

    constructor() {
        super();
    }
}
